import { render, staticRenderFns } from "./CommissionsRefundsList.vue?vue&type=template&id=f406f4a8&"
import script from "./CommissionsRefundsList.vue?vue&type=script&lang=js&"
export * from "./CommissionsRefundsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports